interface FormPreviewProps {
  requireReason: boolean;
  reasonLabel: string;
}

export function FormPreview({ requireReason, reasonLabel }: FormPreviewProps) {
  return (
    <div>
      <h3
        style={{
          fontSize: '0.95rem',
          fontWeight: 600,
          color: '#00303c',
          marginBottom: '1rem',
        }}
      >
        Aperçu du formulaire
      </h3>
      <div
        style={{
          padding: '1.5rem',
          background: '#f8fafb',
          borderRadius: '12px',
          border: '1px solid #e5e7eb',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', maxWidth: '500px' }}>
          <PreviewField label="Prénom" required />
          <PreviewField label="Nom" required />
          <PreviewField label="Email" required />
          <PreviewField label="Téléphone" required />

          {requireReason && (
            <div style={{ animation: 'fadeIn 0.3s ease' }}>
              <label
                style={{
                  display: 'block',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  color: '#00303c',
                  marginBottom: '0.25rem',
                }}
              >
                {reasonLabel} <span style={{ color: '#8E0B56' }}>*</span>
              </label>
              <div
                style={{
                  height: '80px',
                  background: 'white',
                  border: '2px solid #00758d',
                  borderRadius: '8px',
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function PreviewField({ label, required }: { label: string; required?: boolean }) {
  return (
    <div>
      <label
        style={{
          display: 'block',
          fontSize: '0.85rem',
          fontWeight: 600,
          color: '#00303c',
          marginBottom: '0.25rem',
        }}
      >
        {label} {required && <span style={{ color: '#8E0B56' }}>*</span>}
      </label>
      <div
        style={{
          height: '40px',
          background: 'white',
          border: '1px solid #d1d5db',
          borderRadius: '8px',
        }}
      />
    </div>
  );
}
